// extracted by mini-css-extract-plugin
module.exports = {"image-drop":"image-placeholder_image-drop__06Ob5","altText":"image-placeholder_altText__z_pgg"};